import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-runfullanalyticsmodal',
  templateUrl: './runfullanalyticsmodal.component.html',
  styleUrls: ['./runfullanalyticsmodal.component.css']
})
export class RunfullanalyticsmodalComponent implements OnInit {
  form_data: any;
  sms_logs: any;
  loan_history: any;
  phone_logs: any;
  credit_bureau: any;
  other_lenders: any;

  constructor() {
  }

  ngOnInit() {
  }

}
